import type { Step } from "react-joyride";

export const promotionRuleCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ສ້າງກົດເສັ້ນທາງການເຕີບໂຕໃໝ່. ເລືອກຈາກຕຳແໜ່ງ, ໄປຕຳແໜ່ງ ແລະ ຕື່ມຂໍ້ມູນເພີ່ມເຕີມ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-rule-create-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການກົດເສັ້ນທາງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-rule-create-form"]',
    content:
      "ເລືອກຈາກຕຳແໜ່ງ, ໄປຕຳແໜ່ງ, ຈຳນວນປີປະສົບການ, ຄຳອະທິບາຍ. ກົດສ້າງເພື່ອບັນທຶກ rule.",
    placement: "top",
  },
];
